import { render, staticRenderFns } from "./CompetitionFormComponent.vue?vue&type=template&id=5f23fbf8&scoped=true&"
import script from "./CompetitionFormComponent.vue?vue&type=script&lang=ts&"
export * from "./CompetitionFormComponent.vue?vue&type=script&lang=ts&"
import style0 from "./CompetitionFormComponent.vue?vue&type=style&index=0&id=5f23fbf8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f23fbf8",
  null
  
)

export default component.exports